const lookRecommendData = {
    HotAndHumid: {
        outfits: ['outfit1.png', 'outfit2.png'],
        weatherItems: ['weatheritem1.png', 'weatheritem2.png'],
        accessories: ['acc1.png', 'acc2.png', 'acc3.png'],
        comments: ['short sleeves', 'short pants']
    },
    HotAndDry: {
        outfits: ['outfit1.png', 'outfit2.png'],
        weatherItems: ['weatheritem1.png', 'weatheritem2.png'],
        accessories: ['acc1.png', 'acc2.png', 'acc3.png'],
        comments: ['short sleeves', 'sunglasses']
    },
    Mild: {
        outfits: ['outfit1.png', 'outfit2.png'],
        weatherItems: ['weatheritem1.png', 'weatheritem2.png'],
        accessories: ['acc1.png', 'acc2.png', 'acc3.png'],
        comments: ['cardigan', 'blazer']
    },
    Chilly: {
        outfits: ['outfit1.png', 'outfit2.png'],
        weatherItems: ['weatheritem1.png', 'weatheritem2.png'],
        accessories: ['acc1.png', 'acc2.png', 'acc3.png'],
        comments: ['slacks', 'coat']
    },
    Cold: {
        outfits: ['outfit1.png', 'outfit2.png'],
        weatherItems: ['weatheritem1.png', 'weatheritem2.png'],
        accessories: ['acc1.png', 'acc2.png', 'acc3.png'],
        comments: ['muffler', 'fur boots']
    },
    HotRainy: {
        outfits: ['outfit1.png', 'outfit2.png'],
        weatherItems: ['weatheritem1.png', 'weatheritem2.png'],
        accessories: ['acc1.png', 'acc2.png', 'acc3.png'],
        comments: ['umbrella', 'rainboots']
    },
    ColdRainy: {
        outfits: ['outfit1.png', 'outfit2.png'],
        weatherItems: ['weatheritem1.png', 'weatheritem2.png'],
        accessories: ['acc1.png', 'acc2.png', 'acc3.png'],
        comments: ['umbrella', 'rainboots']
    }
};

export default lookRecommendData;
